import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import actions from 'actions/customerGroups'
import selectors from 'selectors'
import Component from 'components/Customers/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  customerGroups: selectors.customerGroups.selectOptions(state),
})

export default connect(mapStateToProps, { getCustomerGroups: actions.getOptions })(Component)
